import { render, staticRenderFns } from "./DailyPanel.vue?vue&type=template&id=2555fa10&scoped=true&"
import script from "./DailyPanel.vue?vue&type=script&lang=js&"
export * from "./DailyPanel.vue?vue&type=script&lang=js&"
import style0 from "./DailyPanel.vue?vue&type=style&index=0&id=2555fa10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2555fa10",
  null
  
)

/* custom blocks */
import block0 from "./DailyPanel.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports